export default __webpack_public_path__ + "static/media/gettin-started.90183c01.svg";